import { Injectable, inject } from '@angular/core';
import { BaseCommandRepository } from '@okcargo-apps/shared-infrastructure';
import {
  ArriveFreightStopCommand,
  ArriveFreightStopCommandHandler,
  DepartFreightStopCommand,
  DepartFreightStopCommandHandler,
  RequestPayInAdvanceCommand,
  RequestPayInAdvanceCommandHandler,
  UploadFreightDocumentCommand,
  UploadFreightDocumentCommandHandler,
  VerifyFreightStopGoodsInfoCommand,
  VerifyFreightStopGoodsInfoCommandHandler,
} from '@okcargo/command-processor';

@Injectable({ providedIn: 'root' })
export class FreightCommandService {
  private readonly arriveFreightStopCommandHandler: ArriveFreightStopCommandHandler;
  private readonly departFreightStopCommandHandler: DepartFreightStopCommandHandler;
  private readonly verifyFreightStopGoodsInfoCommandHandler: VerifyFreightStopGoodsInfoCommandHandler;
  private readonly uploadFreightDocumentCommandHandler: UploadFreightDocumentCommandHandler;
  private readonly requestPayInAdvanceCommandHandler: RequestPayInAdvanceCommandHandler;

  constructor() {
    const commandRepository = inject(BaseCommandRepository);

    this.arriveFreightStopCommandHandler = new ArriveFreightStopCommandHandler(commandRepository);
    this.departFreightStopCommandHandler = new DepartFreightStopCommandHandler(commandRepository);
    this.verifyFreightStopGoodsInfoCommandHandler = new VerifyFreightStopGoodsInfoCommandHandler(commandRepository);
    this.uploadFreightDocumentCommandHandler = new UploadFreightDocumentCommandHandler(commandRepository);

    // TODO move to another service
    this.requestPayInAdvanceCommandHandler = new RequestPayInAdvanceCommandHandler(commandRepository);
  }

  public arriveToFreightStop(command: ArriveFreightStopCommand): Promise<void> {
    return this.arriveFreightStopCommandHandler.handle(command);
  }

  public departFromFreightStop(command: DepartFreightStopCommand): Promise<void> {
    return this.departFreightStopCommandHandler.handle(command);
  }

  public verifyFreightStopGoodsInfo(command: VerifyFreightStopGoodsInfoCommand): Promise<void> {
    return this.verifyFreightStopGoodsInfoCommandHandler.handle(command);
  }

  public uploadFreightDocument(command: UploadFreightDocumentCommand): Promise<void> {
    return this.uploadFreightDocumentCommandHandler.handle(command);
  }

  // TODO move to another service
  public requestPayInAdvance(command: RequestPayInAdvanceCommand): Promise<void> {
    return this.requestPayInAdvanceCommandHandler.handle(command);
  }
}
